import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './navbar.css';
import JoinDiscordButton from './images/join_discord.png';

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [currentPage, setCurrentPage] = useState(location.pathname);

    const handleLinkClick = (page) => {

        // if (page === 'kickstarter') {
        //     window.open('https://www.kickstarter.com/projects/jenkins69/relic-arena', '_blank', 'noopener,noreferrer');
        // } else {
            if (page === 'home') {
                navigate('/');
            } else {
                navigate('/' + page);
            }
            setCurrentPage(page);
        // }
    };

    return (
        <header className="App-header">
            <div className="navbar">
                <div className="navbar-content">
                    <div key="logo" onClick={() => handleLinkClick('home')} className="navbar-logo"></div>
                    <nav className="navbar-menu">
                        {['home', 'faq', 'relics', 'leaders', 'subscribe'].map((page) => (
                            <span
                                key={page}
                                className={currentPage === page ? 'active' : ''}
                                onClick={() => handleLinkClick(page)}
                            >
                                <span className="link-text">
                                    {page === 'faq' ? page.toUpperCase() : page.charAt(0).toUpperCase() + page.slice(1)}
                                </span>
                            </span>
                        ))}
                    </nav>
                    <nav className="navbar-social">
                        <a className="navbar-social-discord" href="https://discord.gg/uVN64WHzxp" target="_blank" title="Discord">
                            <img src={JoinDiscordButton} alt="Join Discord"/>
                        </a>
                        <a href="https://www.youtube.com/channel/UCVWfEoA3-EIVi5gy3Rsibyg" target="_blank" title="Youtube">
                            <span className="link-image link-image-youtube"></span>
                        </a>
                        <a href="https://twitter.com/relicarena" target="_blank" title="Twitter">
                            <span className="link-image link-image-twitter"></span>
                        </a>
                        <a href="https://www.instagram.com/relicarena" target="_blank" title="Instagram">
                            <span className="link-image link-image-instagram"></span>
                        </a>
                        <a href="https://www.facebook.com/relicarena" target="_blank" title="Facebook">
                            <span className="link-image link-image-facebook"></span>
                        </a>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
